import { Link } from "react-router-dom";
import { Reveal, SectionHead } from "@/components/Reveal";
import { APPLICATIONS } from "@/data/content";
import { ArrowRight } from "lucide-react";

export const Applications = () => (
  <section className="border-y border-white/5 bg-[#0c1319] py-24 md:py-36" data-testid="applications-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
      <SectionHead nr="06" overline="Toepassingen" title="Ontworpen voor risicogebieden binnen de recyclingsector" />
      <div className="mt-14 grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
        {APPLICATIONS.map((app, i) => {
          const params = new URLSearchParams({ gebied: app.area });
          if (app.type) params.set("type", app.type);
          return (
            <Reveal key={app.id} delay={(i % 4) * 0.08} className="h-full">
              <article className="group flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#10232F]/40 transition-[border-color,transform] duration-500 hover:-translate-y-1.5 hover:border-[#62C3F0]/40">
                <div className="relative h-40 overflow-hidden">
                  <img
                    src={app.image}
                    alt={app.alt}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#10232F] to-transparent" />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-heading text-base font-bold text-[#F5F7F9]">{app.title}</h3>
                  <p className="mt-2.5 flex-1 text-sm leading-relaxed text-[#CBD3D9]/80">{app.text}</p>
                  <Link
                    to={`/offerte?${params.toString()}`}
                    className="mt-5 inline-flex items-center gap-2 font-heading text-xs font-semibold uppercase tracking-[0.15em] text-[#62C3F0] transition-colors hover:text-[#F5F7F9]"
                    data-testid={`application-cta-${app.id}`}
                  >
                    Bespreek deze toepassing <ArrowRight size={14} />
                  </Link>
                </div>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
